import { render, staticRenderFns } from "./PlayerTableMini.vue?vue&type=template&id=61349d7d&scoped=true&"
import script from "./PlayerTableMini.vue?vue&type=script&lang=js&"
export * from "./PlayerTableMini.vue?vue&type=script&lang=js&"
import style0 from "./PlayerTableMini.vue?vue&type=style&index=0&id=61349d7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61349d7d",
  null
  
)

export default component.exports